import { environment } from '../../../environments/environment';
import { isImpersonatedToken, decodeIamClaims } from './jwt-claims.util';
import { ImpersonationEnvironment, resolveImpersonationEnvironment } from './impersonation-target.util';
import { buildSessionHandoffUrl } from './session-handoff.util';
import { TokenDto } from '../services/auth/models/token.dto';

export type ImpersonationHandoffDecision =
  | { type: 'accept'; token: TokenDto }
  | { type: 'redirect'; url: string }
  | { type: 'reject' };

export function decideImpersonationHandoff(
  token: TokenDto | null,
  current: ImpersonationEnvironment,
): ImpersonationHandoffDecision {
  if (!token || !isImpersonatedToken(token.token)) {
    return { type: 'reject' };
  }

  const claims = decodeIamClaims(token.token);
  const target = resolveImpersonationEnvironment({
    context: claims.context,
    roles: claims.roles,
  });

  if (target === current) {
    return { type: 'accept', token };
  }

  if (target === 'tenant' || target === 'student') {
    const base = target === 'tenant' ? environment.apps.tenant : environment.apps.student;
    return {
      type: 'redirect',
      url: buildSessionHandoffUrl(`${base.replace(/\/$/, '')}/impersonate`, token),
    };
  }

  return { type: 'reject' };
}
